<template>
    <mc-select
        v-model="model"
        :source="list"
        v-bind="attrs"
        class="tree-select"
        v-on="$listeners"
    />
</template>

<script>
/**
 * 门店选择器 （vss）
 */
export default {
    name: 'PoiSelectForVss',
    props: {
        value: {
            type: [String, Number, Array],
            required: true,
            default: '',
        },
        poiType: {
            type: [String, Number],
            default: () => '',
        },
        /**
         * 是否查询全量的门店
         * true: 查询全量的门店
         * false: 查询当前供应商绑定的门店
         */
        flag: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            list: [],
        };
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        attrs() {
            return {
                placeholder: '请选择',
                ...this.$attrs,
            };
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            // 开启缓存
            const { flag, poiType } = this;
            const res = await this.$hGet('/api/m/vss/poi/list', { flag, poiType }, { cache: true });
            const list = (res || []).map((v) => ({
                ...v,
                value: v.poiId,
                label: v.name,
            }));

            this.list = list;
            this.$emit('loaded', list);
        },
    },
};
</script>
